import { render } from "./wizardStepHeader.vue?vue&type=template&id=171f49ed"
import script from "./wizardStepHeader.vue?vue&type=script&lang=js"
export * from "./wizardStepHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__